import { render, staticRenderFns } from "./AssignContractAddRoya.vue?vue&type=template&id=2fbc5750&"
import script from "./AssignContractAddRoya.vue?vue&type=script&lang=js&"
export * from "./AssignContractAddRoya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports